import { render, staticRenderFns } from "./LeaderboardContent.vue?vue&type=template&id=0388b152&scoped=true&"
import script from "./LeaderboardContent.vue?vue&type=script&lang=js&"
export * from "./LeaderboardContent.vue?vue&type=script&lang=js&"
import style0 from "./LeaderboardContent.vue?vue&type=style&index=0&id=0388b152&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0388b152",
  null
  
)

export default component.exports